namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    
    export class AnnotateController {
        
        public cmd: SetNotesTaskCommand;
        public canDelete: boolean = false;
        
        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
                private minhasTarefasService: MinhasTarefasService,
                private task: ITask) {
            this.cmd = new SetNotesTaskCommand(task.context, task.id);
           
            if (!!task.notes) {
                this.cmd.notes = task.notes;
                this.canDelete = true;
            }
        }
        
        public deleteTaskNotes(): void {
            this.cmd.notes = null;
            this.annotateTask();
        }

        public annotateTask(): void {
            this.minhasTarefasService.setNotes(this.cmd)
                .then(() => {
                    this.task.notes = this.cmd.notes;
                    this.$mdDialog.hide();
                });
        }
        
        public closeDialog(): void {
            this.$mdDialog.hide();
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.AnnotateController", AnnotateController);
}